export const queryKeys = {
  accessToken: 'accessToken',
  user: 'user',
  prompt: 'prompts',
  roadmaps: 'roadmaps',
  roadmapById: 'roadmapById',
};
